import React, { useContext } from "react";
import { BefPluginService } from "./bef-plugin-service";
import { BefGlobalContext, BefMetaDataServiceContext, BefPageServiceContext } from "@beflam/bef-core";

export const BefPluginServiceContext = React.createContext<BefPluginService>(null!);

export function BefPluginServiceProvider(props: any) {
    const metaDataService = useContext(BefMetaDataServiceContext);
    const pageService = useContext(BefPageServiceContext);
    const globalService = useContext(BefGlobalContext);
    const befUser = new BefPluginService(metaDataService, pageService, globalService);
    return (
        <BefPluginServiceContext.Provider value={befUser}>
            {props.children}
        </BefPluginServiceContext.Provider>
    );
}